import React, { createContext, useState } from 'react';


const getInitialDeleteFlowVersionState = () => ({
  open: false,
});

export const FlowVersionHistoryContext = createContext({});

export const FlowVersionHistoryProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);
  const [deleteFlowVersionDialog, setDeleteFlowVersionDialog] = useState(() => (
    getInitialDeleteFlowVersionState()
  ));

  const openModal = (flowDetails) => {
    setIsOpen(true);
    setModalDetails(flowDetails);
  };
  const closeModal = () => {
    setIsOpen(false);
    setModalDetails(null);
  };

  const handleDeleteFlowVersionDialogOpen = ({ runCount, version, crFlow }) => {
    setDeleteFlowVersionDialog(prevState => ({
      ...prevState,
      open: true,
      runCount,
      version,
      crFlow,
    }));
  };
  const handleDeleteFlowVersionDialogClose = () => {
    setDeleteFlowVersionDialog(() => getInitialDeleteFlowVersionState());
  };

  const value = {
    isOpen,
    modalDetails,
    setModalDetails,
    openModal,
    closeModal,
    deleteFlowVersionDialog,
    handleDeleteFlowVersionDialogOpen,
    handleDeleteFlowVersionDialogClose,
  };
  return (
    <FlowVersionHistoryContext.Provider value={value}>
      {children}
    </FlowVersionHistoryContext.Provider>
  );
};
